import { render, staticRenderFns } from "./ac-resource.vue?vue&type=template&id=63b742db&scoped=true&"
import script from "./ac-resource.vue?vue&type=script&lang=js&"
export * from "./ac-resource.vue?vue&type=script&lang=js&"
import style0 from "./ac-resource.vue?vue&type=style&index=0&id=63b742db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b742db",
  null
  
)

export default component.exports